import {
  apiCreateDepartment,
  apiGetAllDepartment,
  apiGetAllDept,
  apiGetDetailDept,
  apiUpdateDepartment,
  apiDeleteDepartment,
} from "./urls"
import http from "../index"

const getAllDept = params => http.get(apiGetAllDept, { params })
const getAllDepartment = params => http.get(apiGetAllDepartment, { params })
const createDepartment = body => http.post(apiCreateDepartment, body)
const updateDepartment = (id, body) => http.put(apiUpdateDepartment(id), body)
const getDetailDept = id => http.get(apiGetDetailDept(id))
const deleteDepartment = id => http.delete(apiDeleteDepartment(id))

const DepartmentService = {
  getAllDept,
  getAllDepartment,
  createDepartment,
  updateDepartment,
  getDetailDept,
  deleteDepartment,
}
export default DepartmentService
